import React from 'react';
const RequiredLabel = React.memo((props) => {
    var _a, _b, _c;
    const label = (_a = props.label) !== null && _a !== void 0 ? _a : '必須';
    const colorclass = (_b = props.label) !== null && _b !== void 0 ? _b : 'bg-red-500';
    const optionclass = (_c = props.optionclass) !== null && _c !== void 0 ? _c : '';
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: "p-1 text-white rounded-lg whitespace-nowrap min-w-min h-6 my-auto " + colorclass + ' ' + optionclass }, label)));
});
export default RequiredLabel;
